export type AutomationConditionUI = {
	scene_id: string;
	on_run_or_on_exe: 'triggered' | 'triggered_do';
};

export function is_automation_condition_ui(o: any): o is AutomationConditionUI {
	return (
		typeof o === 'object' &&
		typeof o.scene_id === 'string' &&
		o.scene_id !== '' &&
		(o.on_run_or_on_exe === 'triggered' || o.on_run_or_on_exe === 'triggered_do')
	);
}
